import type RouterDSL from "@ember/routing/-private/router-dsl";

export default function compoundSurveyRoutes(this: RouterDSL) {
  this.route("compound-surveys", function () {
    this.route("edit", function () {
      this.route("survey-completed", { path: "/:je_id" });
    });
    this.route("new", { path: "/:survey_id" });
    this.route("results");
  });
}
